import React from 'react'
import image4 from "../img/urn-newsml-dpa-com-20090101-190401-99-630624-large-4-3.jpg"

const Slide4 = () => {
    return (
        <div className="">
            <div className="container">
                <div class="head"></div>
                <div className="text">
                    Bisher hat die Politik den Klimaschutz zu zögerlich und halbherzig behandelt.
                    Auch das Bundesverfassungsgericht hat kürzlich gefordert:
                    Deutschland muss mehr, schneller und konsequenter handeln.
                    Die Probleme brauchen Lösungen, zupackende Kompetenz und politische Verantwortlichkeit. 
                    <span>Unsere grüne Partei hat dafür die Konzepte und die Persönlichkeiten – im Bund,
                    in den Ländern und in den Städten.</span>
                </div>
                <div className="image image4">
                    <img src={image4} alt=""></img>
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide4;